import type { FC } from 'react';
import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData, graphql } from '@packages/gql/generated/shopping';
import { CategoryFilterStandalone } from '../CategoryFilterStandalone';
import type { UseCategoryDataForFilterNavigationMobileFragment } from './useCategoryDataForFilterNavigationMobile';
import { useCategoryDataForFilterNavigationMobile } from './useCategoryDataForFilterNavigationMobile';
import type { ParentNavigation } from '../../api/rest/types';

export const CategoryFilterNavigationMobileFragment = graphql(/* GraphQL */ `
  fragment CategoryFilterNavigationMobileFragment on FlatCategoryItem {
    ...UseCategoryDataForFilterNavigationMobileFragment
  }
`);

export type CategoryFilterNavigationMobileProps = {
  /** Category items for list navigation */
  maskedItems: FragmentType<typeof CategoryFilterNavigationMobileFragment>[];
  /** Root category for upwards navigation */
  root: ParentNavigation;
  /** Callback invoked when a category is selected */
  onNavigate?: () => void;
};

/**
 * Displays a single level of categories as navigation items, including upwards if possible.
 * */
export const CategoryFilterNavigationMobile: FC<CategoryFilterNavigationMobileProps> = ({
  maskedItems,
  root,
  onNavigate,
}) => {
  const items = getFragmentData(CategoryFilterNavigationMobileFragment, maskedItems);

  const categories = useCategoryDataForFilterNavigationMobile(
    items as FragmentType<typeof UseCategoryDataForFilterNavigationMobileFragment>[],
    root,
  );

  return <CategoryFilterStandalone categories={categories} onNavigate={onNavigate} />;
};
